// Third party
import React from 'react';

// Components
import ComparisonTopBarBaseMenuItem from './ComparisonTopBarBaseMenuItem';

// Utils
import { FormattedMessage } from '../../../../../utils/i18n';

type Props = {
  isLightVersion?: boolean;
};

const ComparisonTopBarStatusMenuItem = (props: Props) => (
  <ComparisonTopBarBaseMenuItem
    className="status-menu-item"
    nonClickable
    label={<FormattedMessage id="SiteNavigation.Status" />}
    content={
      <span className="pastille-read-only">
        <FormattedMessage id="Common.ReadOnly" />
      </span>
    }
  />
);

export default ComparisonTopBarStatusMenuItem;
